import { styled } from '@mui/material'
import { FormEvent, useCallback, useRef, useState } from 'react'
import { t } from '$i18n'
import { useClientUser } from '$logic/client-user'
import { closeDeleteAccount } from '$logic/router'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackTitle } from '$common/app-bar/app-bar-back-title'
import { EnterOtpForm, EnterOtpFormApi } from './components/enter-otp-form'
import {
  RequestOtpForm,
  RequestOtpFormApi,
} from './components/request-otp-form'

export function DeleteAccount() {
  const [sessionId, setSessionId] = useState<string>()

  const { phone = '' } = useClientUser()

  const enterOtpFormApi = useRef<EnterOtpFormApi>(null)
  const requestOtpFormApi = useRef<RequestOtpFormApi>(null)

  // NOTE: We shouldn't delegate handling loading to ErrorButton because confirm can be triggered
  // by submitting form with enter button
  const handleConfirm = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault()
      if (sessionId) enterOtpFormApi.current?.handleConfirm()
      else if (phone) {
        const { sessionId: sid } =
          (await requestOtpFormApi.current?.sendOtp(phone)) || {}
        setSessionId(sid)
      }
    },
    [phone, sessionId],
  )

  return (
    <PageWithAppBar
      rootSx={{ textAlign: 'right' }}
      appBar={
        <AppBarBackTitle
          title={t('settings.deleteAccount.title')}
          onBack={closeDeleteAccount}
        />
      }
    >
      <Root onSubmit={handleConfirm}>
        {sessionId ? (
          <EnterOtpForm
            phone={phone}
            sessionId={sessionId}
            ref={enterOtpFormApi}
          />
        ) : (
          <RequestOtpForm
            onCancel={closeDeleteAccount}
            ref={requestOtpFormApi}
          />
        )}
      </Root>
    </PageWithAppBar>
  )
}

const Root = styled('form')`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 48px 24px 24px;
  position: relative;
`
